import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss'],
    standalone: false // NOSONAR
})
export class PopupComponent {
  private params!: any;
  checks = false;
  e: any;
  list:any[];
  res:any;
  newArr:any=[];
  currentValue: number | null | string = null;
  selectAll: boolean = false;
  // currentValue: any = null;
  constructor() {}

  agInit(params: any): void {
    this.params = params;
    
    this.list = [
      {
        value: 0,
        title: 'Missed Next Connection',
        checked: false,
      },
      {
        value: 1,
        title: 'Partial Missed Next Connection',
        checked: false,
      },
      {
        value: 2,
        title: 'Missed Unload',
        checked: false,
      },
      {
        value: 3,
        title: 'Partial Missed Unload',
        checked: false,
      },
      {
        value: 4,
        title: 'Tracked for Impact',
        checked: false,
      },
      {
        value: 5,
        title: 'Partial Tracked for Impact',
        checked: false,
      },
      {
        value: 6,
        title: 'All Freight Moved to Resolution',
        checked: false,
      },
      {
        value: 8,
        title: 'ETA is After the Plant Unload',
        checked: false,
      },    
    ]
  }

  bulk(e) {
    if (e.target?.checked == true) {   // NOSONAR
      this.checks=true;
    } else {
      this.checks = false;
    }
  }

  applyFilter(_event){
    this.res=[];
    this.res=this.list.filter(item => item.checked);
    this.checkSelectAll();
    const callback =
      this.params?.filterChangedCallback ||
      this.params?.floatingFilterComponentParams?.filterChangedCallback ||
      this.params?.filterParams?.filterChangedCallback ||
      this.params?.colDef?.floatingFilterComponentParams?.filterChangedCallback;

    const colId =
      this.params?.column?.colId ||
      this.params?.colDef?.colId ||
      this.params?.colDef?.field ||
      this.params?.column?.getColId?.() ||
      this.params?.column?.getId?.();

    let invoked = false;

    if (typeof callback === 'function' && colId) {
      callback(this.res, colId);
      invoked = true;
    }

    const contextHistoryComponent =
      this.params?.context?.historyComponent ||
      this.params?.api?.getGridOption?.('context')?.historyComponent;

    if (contextHistoryComponent?.filterColumns && colId) {
      contextHistoryComponent.filterColumns(this.res, colId);
    }
    
  }

  checkSelectAll() {
    if(this.list.length) {
      const unSelectedFound = this.list.find(item => item.checked == false);    // NOSONAR
      if(unSelectedFound) {
        this.selectAll = false;
      } else {
        this.selectAll = true;
      }
    }
 }

  result() {
    return this.list.filter(item => item.checked);
  }

  selectAllFunc(value) {
    // selectAllCheckBox value = true...
    if(value) {
      this.list?.forEach((col) => {
        col.checked=true;
      })    
    } else {
      // selectAllCheckBox value = false...
      this.list?.forEach((col) => {
        col.checked=false;
      })
    }
    this.applyFilter(this.list);
  }

  onParentModelChanged(parentModel: any) {
    if (!parentModel) {
      this.currentValue = null;
    } else {
      parentModel.type='contains';
      this.currentValue = parentModel.filter;
    }
  }

  onInputBoxChanged(_event) {
    this.res=[];
    this.newArr=[]
    this.res=this.list?.filter(item => item.checked);
    this.res.forEach(element => {
      if (!this.newArr.includes(element.value)) {
        this.newArr.push(element.value);
    }
    });
    
    if (this.newArr.length>0) {
      this.currentValue = this.newArr;
      
    } else {
      this.currentValue = '';
    }
    
    if (!this.currentValue) {
      this.params?.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged(null, null);
      });
      return;
    }
    this.currentValue = Number(this.currentValue);
    this.params?.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged('greaterThan', this.currentValue);
    });
  }
}
